export const ITEM_HEIGHT = 33
export const MAX_DISPLAYED_ITEMS = 50
